import { PropsWithChildren } from 'react';
import { CalendarViewProvider, CalendarViewProps } from './providers';

export const CalendarView = ({
  id = 'calendar-view-container',
  startHour = 0,
  endHour = 24,
  onEventCreate,
  data,
  EventCardComponent,
  EmptyCalendarComponent,
  shouldAllowEventCreation = true,
  calendarDate,
  children,
}: PropsWithChildren<CalendarViewProps>) => {
  return (
    <CalendarViewProps.Provider
      value={{
        data,
        startHour,
        endHour,
        onEventCreate,
        id,
        EventCardComponent,
        EmptyCalendarComponent,
        shouldAllowEventCreation,
        calendarDate,
      }}
    >
      <CalendarViewProvider>{children}</CalendarViewProvider>
    </CalendarViewProps.Provider>
  );
};
